import React from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';

const getSubCategoryIcon = (source) => {
    return `https://cloud.paysend.com/images/sub_category_images/${source.icon}.png`;
};

const SubSource = (props) => {
    return (
        <Panel type="button" onClick={(e) => props.selectSubSource(e, props.source, props.isShowDisclaimer)} isHoverable negativeMargin>
            <DiskBadgeWrapper>
                <DiskBadge src={getSubCategoryIcon(props.source)} alt={props.source.icon} />
            </DiskBadgeWrapper>
            <PanelContent>
                <PanelRow>
                    <Text color="primary">{props.source.sourceName}</Text>
                </PanelRow>
                <PanelRow>
                    <Text size="secondary" color="lightGray">
                        <DangerouslyHtml dangerouslyHtml={props.source.comment} />
                    </Text>
                </PanelRow>
            </PanelContent>
        </Panel>
    );
};

SubSource.propTypes = {
    source: PropTypes.object.isRequired,
    isShowDisclaimer: PropTypes.bool.isRequired,
    selectSubSource: PropTypes.func.isRequired,
};

export default SubSource;
